<legend *ngIf="to.label">{{ to.label }}</legend>
<p *ngIf="to.description">{{ to.description }}</p>

<txp-message [type]="messageType.DANGER" *ngIf="showError && formControl.errors">
    <formly-validation-message [field]="field"></formly-validation-message>
</txp-message>

<formly-field *ngFor="let f of field.fieldGroup" [field]="f"></formly-field>
